
import { PrivacyComponent } from './privacy/privacy.component';
import { environment } from './../../../environments/environment';
import { DashboardService } from './../../core/services/dashboard.service';
import { AuthService } from './../../core/services/auth.service';
import { AuthModule } from './../../core/store/auth/auth.module';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { AgmCoreModule } from '@agm/core';
import { MapComponent } from './map/map.component';
import { RightNavigationComponent } from './header/right-nav/right-nav-component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { RouterModule, Routes } from '@angular/router';
import { LoginFormComponent } from './login/login-view/login-form/login-form.component';
import { LoginViewComponent } from './login/login-view/login-view.component';
import { HeaderComponent } from './header/header.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ResultsHeaderComponent } from './header/results-header/results-header.component';
import { CoreStoreModule } from '../../core/store/core-store.module';
import { GeneralStoreModule } from '../../core/store/general/search-store.module';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { NotFoundComponent } from './not-found/not-found.component';
import { MobileLoginFormComponent } from './login/login-view/login-form-mobile/mobile-login-form.component';
import { SocialLoginModule, SocialAuthServiceConfig } from 'angularx-social-login';
import { GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';
import { FilterPipe } from '../pipes/filter.pipe';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CookiesComponent } from './cookies/cookies.component';
import { BackToTopComponent } from './back-to-top/back-to-top.component';
import { LoginPageComponent } from './login/logn-page/login-page';
import { ApplicationFormComponent } from './application-form/application-form.component';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { NgxSpinnerModule } from 'ngx-spinner';


const routes: Routes = [
  { path: 'login-page', component: LoginPageComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    ModalModule.forRoot(),
    FormsModule,
    MatSliderModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    NgxSpinnerModule,
    RouterModule,
    AgmCoreModule.forRoot({
      apiKey: environment.production === true ? 'AIzaSyAYkqptkbT-A4acvKS707mfxR_WhzniVag' : 'AIzaSyC2EL92JX6uaz_ScPL9sYx4trojQvlytzg'
    }),
    AgmJsMarkerClustererModule,
    AgmSnazzyInfoWindowModule,
    CoreStoreModule,
    AuthModule.forRoot(),
    GeneralStoreModule.forRoot(),
    SocialLoginModule,
    MatPasswordStrengthModule,
    RouterModule.forRoot(routes, { anchorScrolling: 'enabled' }),
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    LoginViewComponent,
    LoginFormComponent,
    PaymentDetailsComponent,
    ResultsHeaderComponent,
    LoginPageComponent,
    RightNavigationComponent,
    MapComponent,
    NotFoundComponent,
    PrivacyComponent,
    MobileLoginFormComponent,
    AboutUsComponent,
    ContactUsComponent,
    FilterPipe,
    AboutUsComponent,
    CookiesComponent,
    BackToTopComponent,
    ApplicationFormComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    LoginViewComponent,
    MatSliderModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    ModalModule,
    PaymentDetailsComponent,
    MapComponent,
    FilterPipe,
    ApplicationFormComponent,
    ContactUsComponent
  ],
  providers: [
    AuthService,
    GeneralStoreModule,
    DashboardService,
    {

      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '993690688389-ie7icqv260mr1bqis9cu7io8hm9a7nnu.apps.googleusercontent.com'
            ),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(
              '1780834228798883'
            ),
          },
        ],
      } as SocialAuthServiceConfig,
    }
  ]
})

export class SharedModule { }
